import useTikTokDisclosureStep from './useTikTokDisclosureStep';

export default useTikTokDisclosureStep;
